export default __webpack_public_path__ + "6138b2514ba433199dde1df3a0298186.svg";